import { ReactNode } from "react";
import { Icon, IconKeyProp, TooltipV2, TooltipV2Props } from "~components";
import { Css } from "~generated/css";
import { useTestIds } from "~utils";

type IconTooltipProps = {
  type: "info" | "warning"; // | "error";
  icon?: IconKeyProp;
  title?: ReactNode;
  message: ReactNode;
  contrast?: boolean;
} & Partial<Pick<TooltipV2Props, "width" | "positionStrategy" | "noArrow" | "openOnClick" | "place">>;

export function IconTooltip(props: IconTooltipProps) {
  const { type, positionStrategy = "fixed", title, message, icon, contrast = false, ...tooltipStyle } = props;
  const tid = useTestIds(props, `${type}-icon-tooltip`);

  return (
    // Note: why mrPx(-12) and a random inset?
    // Because this hack forces the icon to wrap alongside text as if it were part of the string while
    // maintaing center alignment.
    <div {...tid} css={Css.dif.relative.sqPx(12).mrPx(-12).add("inset", "2px").$}>
      <div css={Css.df.asc.$} {...tid.trigger}>
        {/* TODO: We need an updated "info-icon-purple" thats sized at 12x12 if we ever start bringing in option description tooltips */}
        <Icon
          name={icon || type === "info" ? (contrast ? "info-icon-white" : "info-icon-gray") : "warning-icon-small"}
        />
      </div>
      <TooltipV2
        {...tid.tooltip}
        positionStrategy={positionStrategy}
        title={title}
        // data-testid isn't a named property of TestIds
        // @ts-ignore
        anchorSelect={`[data-testid='${tid.trigger["data-testid"]}']`}
        {...tooltipStyle}
      >
        {message}
      </TooltipV2>
    </div>
  );
}
